import { useTheme } from "@hooks/useTheme";

const LoadingSpinner = ({
  bgClass,
  size = 12,
  "data-testid": dataTestId = "loading-spinner",
}) => {
  const { colors } = useTheme();

  return (
    <div
      className={`flex h-full items-center justify-center ${bgClass || colors.bgSecondary}`}
      data-testid={dataTestId}
    >
      <div className="text-center" data-testid={`${dataTestId}-content`}>
        <div
          className={`animate-spin rounded-full h-${size} w-${size} border-b-2 ${colors.borderLoader} mx-auto`}
          data-testid={`${dataTestId}-indicator`}
        ></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
